var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.step || _vm.step === 1)?_c('div',{staticClass:"u-container"},[_c('CheckPassword',{on:{"changeStep":_vm.changeStep}})],1):_vm._e(),(_vm.step === 2)?_c('div',{staticClass:"u-container"},[_c('EditUserForm')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }